// arsivIzi.js — ARŞİVLENMİŞ UÇUŞ DÜZELTMESİ: İZ ÖNCE + RAPOR YENİLEME SONUCU — TEK KAYNAK (21 Eki 2026, kod taraması W4b)
//
// 🔑 Serkan (21 Eki 2026, "a"): iz önce yazılır; yazma reddedilirse az önce yazılan iz satırları "… NOT WRITTEN" diye
//    işaretlenir.
// 🔴 ÖNCESİ: arşivlenmiş uçuşu düzelten DÖRT yol vardı (ARCHIVED FLTS modül kutuları · EDIT · DELETE · FTL EDIT'in arşiv
//    ayağı). Üçü kaydı ÖNCE değiştirip izi SONRA yazıyordu (ikisi hatasına hiç bakmadan) — iz düşerse düzeltme izsiz
//    kalır, raporun AMENDED bandına da girmezdi; DELETE izi önce yazıyordu ama hatasına bakmıyordu.
// 🔑 İNCELİK: `admin_edits` raporun AMENDED bandının da kaynağıdır (web görünümü + sunucu PDF'i yalnız `EDIT` türünü
//    okur). İz önce yazılıp yazma reddedilirse rapor OLMAMIŞ bir düzeltmeyi gösterirdi — bu yüzden iz SİLİNMEZ, türü
//    "EDIT NOT WRITTEN" / "DELETE NOT WRITTEN" olur: raporda görünmez, denetimde deneme ve ret birlikte durur.
import { supabase } from '../supabaseClient';

/** `izler`: admin_edits satırları · `yaz`: DÖNEN SATIRLA (`.select('id')`) yazma · `basarisizTur`: reddedilince iz türü.
 *  Döner { tamam, sebep, izNotu, metin } — `metin` ekrana hazır cümle. */
export async function izOnceYaz(sb, izler, yaz, basarisizTur) {
  const { data: yazilanIz, error: izHatasi } = await sb.from('admin_edits').insert(izler).select('id');
  if (izHatasi || (yazilanIz || []).length !== izler.length) {
    const sebep = `the edit log could not be written (${izHatasi?.message || 'no row returned (permission?)'})`;
    return { tamam: false, sebep, izNotu: '', metin: `NOT SAVED — ${sebep}, so nothing was changed.` };
  }
  const { data, error } = await yaz();
  if (!error && (data || []).length) return { tamam: true };
  const sebep = error?.message || 'no row returned (permission?)';
  const { error: isaretHatasi } = await sb.from('admin_edits').update({ edit_type: basarisizTur }).in('id', yazilanIz.map(x => x.id));
  const izNotu = isaretHatasi
    ? ` The edit log could not be corrected either (${isaretHatasi.message}) — it may show this change although it was not written.`
    : ' The edit log marks the attempt as NOT WRITTEN.';
  return { tamam: false, sebep, izNotu, metin: `NOT SAVED — ${sebep}.${izNotu}` };
}

/** Rapor PDF'ini yeniden üretir ve SONUCU okur: sunucu çalışıp `sorunlar` döndürdüyse (ör. düzeltmeler okunamadığı için PDF
 *  çizilmedi) bu "başarılı" sayılmaz. Eskiden yalnız `error`e bakılıyor, her durumda "regenerated" deniyordu.
 *  Döner { tamam, metin } — `metin` yalnız sorun varsa. */
export async function raporuYenile(planId) {
  let r;
  try { r = await supabase.functions.invoke('archive-flight', { body: { plan_id: planId, regenerate_pdf: true } }); }
  catch (e) { return { tamam: false, metin: `the report PDF regen failed: ${e?.message || String(e)}` }; }
  if (r?.error) return { tamam: false, metin: `the report PDF regen failed: ${r.error.message || String(r.error)}` };
  const sorunlar = Array.isArray(r?.data?.sorunlar) ? r.data.sorunlar : [];
  if (sorunlar.length) {
    return { tamam: false, metin: `the report regen reported ${sorunlar.length} problem(s): ${sorunlar.slice(0, 3).join(' · ')}`
      + (sorunlar.length > 3 ? ` (+${sorunlar.length - 3} more)` : '') };
  }
  return { tamam: true, metin: null };
}
